var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSurgery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    id: "vector",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 60 76 M 32 76 C 32 68.577 34.952 61.45 40.201 56.201 C 45.45 50.952 52.577 48 60 48 C 67.423 48 74.55 50.952 79.799 56.201 C 85.048 61.45 88 68.577 88 76 C 88 83.423 85.048 90.55 79.799 95.799 C 74.55 101.048 67.423 104 60 104 C 52.577 104 45.45 101.048 40.201 95.799 C 34.952 90.55 32 83.423 32 76",
    fill: "#00000000",
    stroke: "#208ce1",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 60 180 M 32 180 C 32 172.577 34.952 165.45 40.201 160.201 C 45.45 154.952 52.577 152 60 152 C 67.423 152 74.55 154.952 79.799 160.201 C 85.048 165.45 88 172.577 88 180 C 88 187.423 85.048 194.55 79.799 199.799 C 74.55 205.048 67.423 208 60 208 C 52.577 208 45.45 205.048 40.201 199.799 C 34.952 194.55 32 187.423 32 180",
    fill: "#00000000",
    stroke: "#208ce1",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M 136 128 L 83.1 164.2",
    fill: "#00000000",
    stroke: "#208ce1",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    d: "M 232 62.3 L 164.3 108.6",
    fill: "#00000000",
    stroke: "#208ce1",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    d: "M 232 193.7 L 83.1 91.8",
    fill: "#00000000",
    stroke: "#208ce1",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSurgery);
export default __webpack_public_path__ + "static/media/ic_surgery.0dea94c4a1f59694bbe2c65333aacf21.svg";
export { ForwardRef as ReactComponent };